var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M15.547 12.953c.914.844.914 2.32 0 3.164l-11.25 11.25a2.17 2.17 0 0 1-3.164 0 2.17 2.17 0 0 1 0-3.164l9.633-9.703-9.633-9.633a2.17 2.17 0 0 1 0-3.164 2.17 2.17 0 0 1 3.164 0z"
  })));
};
export default SvgArrow;